import api from "./api";

const FileManagerAPI = {
    getAll: () => api.get("/file-manager/all"),
    uploadFile: (file) => api.post("/file-manager/upload", file),
    deleteFile: (fileNames) => api.post(`/file-manager/delete-multiple`, fileNames),
};

export default FileManagerAPI;